import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../../incase-domain/components/button/Button';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';
import {IElementTextInput} from '../../../incase-domain/elements/textInput';

interface ElementTextInputProps {
    element: IElementTextInput;
    device?: DeviceType;
}

function ElementTextInput(props: ElementTextInputProps): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;
    const {label, placeholder} = element;
    const {t} = useTranslation();

    return (
        <div className={getElementClasses(device)} style={getElementStyle(device, element)}>
            <label className="c-inputElement__field">
                <div className="c-inputElement__label">{label}</div>
                <input type="text" className="c-inputElement__input" placeholder={placeholder} name={element.htmlName} autoComplete="off" />
            </label>
            {element.confirmButton && (
                <Button type="button" className="c-inputElement__confirm" size="sm" color="info" fullWidth dynamicSize>
                    {t('common.confirm')}
                </Button>
            )}
        </div>
    );
}

function getElementStyle(device: DeviceType, element: IElementTextInput): React.CSSProperties {
    if (device === DeviceType.MOBILE) {
        return {
            fontFamily: element.fontFamily?.name,
        };
    }

    return {
        fontSize: `${element.font.size || 2}em`,
        fontFamily: element.fontFamily?.name,
    };
}

function getElementClasses(device: DeviceType): string {
    if (device === DeviceType.MOBILE) {
        return 'c-inputElement c-inputElement--mobile';
    }

    return 'c-inputElement';
}

export default ElementTextInput;
